import { motion, useMotionValue, useSpring } from 'motion/react';
import { useEffect, useState } from 'react';

export function AmbientCursor() {
  const x = useMotionValue(-300);
  const y = useMotionValue(-300);
  const smoothX = useSpring(x, { stiffness: 80, damping: 26, mass: 0.45 });
  const smoothY = useSpring(y, { stiffness: 80, damping: 26, mass: 0.45 });
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (window.matchMedia('(pointer: coarse)').matches) return;
    const move = (event: PointerEvent) => {
      x.set(event.clientX - 240);
      y.set(event.clientY - 240);
      setVisible(true);
    };
    const leave = () => setVisible(false);
    window.addEventListener('pointermove', move);
    document.documentElement.addEventListener('mouseleave', leave);
    return () => {
      window.removeEventListener('pointermove', move);
      document.documentElement.removeEventListener('mouseleave', leave);
    };
  }, [x, y]);

  return (
    <motion.div
      className="keevo-cursor-glow"
      aria-hidden="true"
      style={{ x: smoothX, y: smoothY, opacity: visible ? 1 : 0 }}
    />
  );
}
